import React from 'react';
import PropTypes from 'prop-types';

export default function StockTickerLeftColumn(props) {
  const{
    open,
    close,
    rangeToday
  } = props.meta.data;
  const{
    formatNumber
  } = props.meta;
  const{
    styles,
    _styles,
    ulStyle,
    liStyle,
    liFormat,
    labelFormat
  } = props.meta.styles;

  return (
    <ul style={ulStyle} className={styles.leftColumn}>
      <li className={[styles.previousClose, _styles.listLI, liFormat].join(' ')}>
        <span className={[_styles.stocksLabel, labelFormat].join(' ')}>
          Prev Close
        </span>
        <span id="prevCloseValue" style={liStyle} className={[_styles.stocksValue].join(' ')}>
          {formatNumber( close, 'decimal' )}
        </span>
      </li>
      <li className={[styles.openPrice,_styles.listLI, liFormat].join(' ')}>
        <span className={[_styles.stocksLabel, labelFormat].join(' ')}>
          Open
        </span>
        <span id="openValue" style={liStyle} className={[_styles.stocksValue].join(' ')}>
          {formatNumber( open, 'decimal' )}
        </span>
      </li>
      <li className={[styles.dayRange,_styles.listLI, liFormat].join(' ')}>
        <span className={[_styles.stocksLabel, labelFormat].join(' ')}>
          Range (Today)
        </span>
        <span id="rangeTodayValue" style={liStyle} className={[_styles.stocksValue].join(' ')}>
          {formatNumber( rangeToday[0], 'decimal' )}
          <span className={_styles.dash}> - </span>
          {formatNumber( rangeToday[1], 'decimal' )}
        </span>
      </li>
    </ul>
  );
}

StockTickerLeftColumn.propTypes = {
  meta: PropTypes.object
};
